;(function($, undefined){

    var rnn = window.rnn;

    var log = rnn.logging.log;

    /////////////////////////////////////////////////////
    // Populate function - used in competitions.js
    ////////////////////////////////////////////////////
    (function($) {
        $.fn.populate = function(val) {
            return this.each(function() {
                var $this = $(this);
                if (val) {
                    $this.val(val);
                }
            });
        };
    })(jQuery);

    /////////////////////////////////////////////////////
    // showPopup - used in competitions
    ////////////////////////////////////////////////////
    var popupDefaults = {
        menubar: 'no',
        location: 'no',
        resizable: 'no',
        scrollbars: 'no',
        status: 'yes',
        width: 660,
        height: 580,
        top: ((screen.availHeight - 340) / 2) -130,
        left: (screen.availWidth - 480) / 2
    };

    function showPopup(event) {
        var settings = $.extend(popupDefaults, $(event.target).closest("[data-popup-window]").data('popupWindow'));

        event.preventDefault();

        window.open(this.href, '', _.map(settings, function (value, key) {
            return '' + key + '=' + value;
        }).join());
    }

    function initPopups() {
        $(document).on('click', '.popupWindow', showPopup);
    }

    //Refresh the homepage, the function we all hate.
    function initHomepage() {
        if (rnn.site.network.isAU && !rnn.site.isDebug && window.location.pathname == "/") {
            setTimeout(function() {
                window.location.reload(false);
            }, 4*60*1000);
        }
    }

    // Initialise Homepage refresh
    function initUtilities() {
        $('.popupWindow').length && initPopups();
        initHomepage();
        preventRightClick();
    }

    function slugify(text) {
        /* Django's slugify filter, in JavaScript! */

        // Remove non-standard characters entirely.
        text = text.replace(/[^\w\s-]/g, '');

        // Strip whitespace from the ends, and make it lowercase.
        text = text.replace(/^\s+/, '').replace(/\s+$/, '').toLowerCase();

        // Remove multiple hyphens/whitespace with a single hyphen.
        text = text.replace(/[-\s]+/g, '-');

        return text;
    }

    function isElementInViewport (el) {
        //special bonus for those using jQuery
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // Check & Display an Error if the Keywords max keyword lenth
    function checkKeywords($keywords_field, max_keyword_length, delimiter) {
        var $control_group = $keywords_field.parents('.control-group'),
            delimiter = delimiter || ',',
            old_tooltip_text = 'Separated by ' + delimiter,
            max_keyword_length = max_keyword_length || 50;

        $keywords_field.on('change, keyup', function(event){
            var value = $(this).val(),
                words = value.split(delimiter),
                $tooltip = $keywords_field.parent().find('.tooltip-inner'),  // Need to look up here, because the tooltip isn't in dom yet
                long_words = [];

            $.each(words, function(index, value){
                var value = $.trim(value);  // "string ".trim() doesn't work in IE8
                if (value.length > max_keyword_length) {
                    long_words.push(value);
                }
            });

            if (long_words.length !== 0) {
                $control_group.addClass('error');
                $tooltip.html('<strong>The following are longer than ' + max_keyword_length + ' characters:</strong> ' + long_words.join(', '));
            } else {
                $control_group.removeClass('error');
                $tooltip.text(old_tooltip_text);
            }
        });
    }

    function removeHash () {
        var scrollV,
            scrollH,
            loc = window.location;

        if ("pushState" in history) {
            history.pushState("", document.title, loc.pathname + loc.search);
        } else {
            // Prevent scrolling by storing the page's current scroll offset
            scrollV = document.body.scrollTop;
            scrollH = document.body.scrollLeft;

            loc.hash = "";

            // Restore the scroll offset, should be flicker free
            document.body.scrollTop = scrollV;
            document.body.scrollLeft = scrollH;
        }
    }

    function hasAllKeys(obj, keys) {
        /* Return boolean indicating if all keys are found on obj. */

        for (var i = 0; i < keys.length; i++) {

            if (!_.has(obj, keys[i])) {
                return false;
            }
        }

        return true;
    }

    function getAndroidVersion() {
        var ua = navigator.userAgent.toLowerCase(),
            match = ua.match(/android\s([0-9\.]*)/);

        return match ? match[1] : false;
    }

    function getIosVersion() {
        var ios = ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
                    .replace('undefined', '3_2').replace('_', '.').replace('_', '') || false;

        return ios;
    }

    function findIntersectors(targetSelector, intersectorsSelector) {
        var intersectors = [];
        var $target = $(targetSelector);
        var tAxis = $target.offset();
        var t_x = [tAxis.left, tAxis.left + $target.outerWidth()];
        var t_y = [tAxis.top, tAxis.top + $target.outerHeight()];

        $(intersectorsSelector).each(function() {
              var $this = $(this);
              var thisPos = $this.offset();
              var i_x = [thisPos.left, thisPos.left + $this.outerWidth()];
              var i_y = [thisPos.top, thisPos.top + $this.outerHeight()];

              if ( t_x[0] < i_x[1] && t_x[1] > i_x[0] &&
                   t_y[0] < i_y[1] && t_y[1] > i_y[0]) {
                  intersectors.push($this);
              }

        });

        return intersectors;
    }

    function selectorEscape(expression) {
        return expression.replace(/[!"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, '\\$&');
    }

    function niceWordTrunc(str, maxChars) {
        if (str.length <= maxChars) {
            return str;
        }
        var maxFit = maxChars - 3;
        var truncateAt = str.lastIndexOf(' ', maxFit);
        if (truncateAt == -1 || truncateAt < maxChars / 2) {
            truncateAt = maxFit;
        }
        var truncatedName = str.substr(0, truncateAt);
        var findWord = truncatedName.lastIndexOf(" ");
        return truncatedName.substr(0, findWord) + "...";
    }
    
    function preventRightClick() {
        // SCRUM-11998: Prevent users from "right click" action
        // AM - Request from Kerri-anne to disable right-click on sites
        
        window.addEventListener('contextmenu', function (e) {
         if (e.target instanceof HTMLImageElement) {
           e.preventDefault();
         }
      }, false);
    }

    rnn.modules.register('utilities', {
        init: initUtilities,
        slugify: slugify,
        checkKeywords: checkKeywords,
        isElementInViewport: isElementInViewport,
        removeHash: removeHash,
        hasAllKeys: hasAllKeys,
        getAndroidVersion: getAndroidVersion,
        getIosVersion: getIosVersion,
        findIntersectors: findIntersectors,
        selectorEscape: selectorEscape,
        niceWordTrunc: niceWordTrunc
    });

})(jQuery);
